function isPageMeantForPwa() {
    const mainElementPage = document.querySelectorAll("main")[0];
    const isPwa = mainElementPage.dataset.pwaPage && mainElementPage.dataset.pwaPage === "yes";
    const isJob = document.getElementById("af-job-page-desktop");
    const isArticleSearch = document.getElementById("af-blog-search-desktop-intro");
    const isArticle = document.getElementById("af-blog-page-mobile-intro");
    const isApplication = document.getElementById("af-application-page-mobile-intro")
    return (isPwa || isJob || isArticleSearch || isArticle || isApplication)
}

export default isPageMeantForPwa;
